import { render, staticRenderFns } from "./carViolation.vue?vue&type=template&id=ee88c0c8&scoped=true"
import script from "./carViolation.vue?vue&type=script&lang=js"
export * from "./carViolation.vue?vue&type=script&lang=js"
import style0 from "./carViolation.vue?vue&type=style&index=0&id=ee88c0c8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee88c0c8",
  null
  
)

export default component.exports